import { render, staticRenderFns } from "./UserProduct.html?vue&type=template&id=a9468418&scoped=true&"
import script from "./UserProduct.ts?vue&type=script&lang=ts&"
export * from "./UserProduct.ts?vue&type=script&lang=ts&"
import style0 from "./UserProduct.css?vue&type=style&index=0&id=a9468418&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9468418",
  null
  
)

export default component.exports